export default __webpack_public_path__ + "static/media/movingProperty.7fe44b57.svg";